import dayjs from "dayjs"
import { ListGroupItem, ListGroupItemProps } from "react-bootstrap"
import { GamePlayedItem } from "../models/UserData";
import { sum } from "../models/Skills";

export interface PlayedGameListItemProps extends ListGroupItemProps {
    gamePlayed: GamePlayedItem;
    onClick: () => void;
}

export const PlayedGameListItem = ({ gamePlayed, onClick, ...props }: PlayedGameListItemProps): React.ReactElement => {
    return (
        <ListGroupItem {...props} action onClick={() => onClick()}><div><strong>{gamePlayed.name}</strong></div><div><em>{dayjs(gamePlayed.playedOn).fromNow()}</em><em style={{ float: 'right' }}>{sum(gamePlayed.xp)} xp</em></div></ListGroupItem>
    )
}